import React from 'react';
import { Users, User } from 'lucide-react';

const ViewSwitcher = ({ currentUser, familyUsers, switchUser }) => {
  // Don't render if currentUser is not set yet
  if (!currentUser || !familyUsers || familyUsers.length === 0) {
    console.log('ViewSwitcher: Not rendering - currentUser or familyUsers not ready');
    return null;
  }
  
  // Only parents should be able to use the view switcher
  const isParent = currentUser?.role === 'parent' || currentUser?.type === 'parent' || currentUser?.isParent;
  if (!isParent) {
    console.log('ViewSwitcher: Not rendering - user is not a parent');
    return null;
  }
  
  const isParentView = currentUser?.isParent || currentUser?.type === 'parent';
  const children = familyUsers?.filter(user => user.type !== 'parent') || [];
  
  console.log('ViewSwitcher render: currentUser:', currentUser);
  console.log('ViewSwitcher render: familyUsers:', familyUsers);
  console.log('ViewSwitcher render: isParentView:', isParentView);
  console.log('ViewSwitcher render: children:', children);
  
  const handleSwitchUser = (user) => {
    console.log('ViewSwitcher: Switching to user:', user);
    console.log('ViewSwitcher: Current user before switch:', currentUser);
    console.log('ViewSwitcher: switchUser function:', switchUser);
    
    if (switchUser && typeof switchUser === 'function') {
      switchUser(user);
    } else {
      console.error('ViewSwitcher: switchUser is not a function:', switchUser);
    }
  };
  
  return (
    <div className="flex items-center gap-2 p-1 bg-slate-100 rounded-lg">
      {/* Parent View Button */}
      <button
        onClick={() => {
          const parentUser = familyUsers.find(user => user.type === 'parent');
          if (parentUser) {
            handleSwitchUser(parentUser);
          }
        }}
        className={`flex items-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-all min-h-[44px] ${
          isParentView 
            ? 'bg-white text-slate-900 shadow-sm' 
            : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
        }`}
      >
        <Users className="w-5 h-5" />
        <span className="hidden sm:inline">Parent View</span>
      </button>

      {/* Student View Buttons */}
      {children.map((child) => (
        <button
          key={child.id}
          onClick={() => handleSwitchUser(child)}
          className={`flex items-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-all min-h-[44px] ${
            !isParentView && currentUser?.id === child.id
              ? 'bg-white text-slate-900 shadow-sm'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
          }`}
        >
          <User className="w-5 h-5" />
          <span className="hidden sm:inline">
            {child.displayName || child.name || child.first_name}
          </span>
          <span className="sm:hidden">
            {(child.displayName || child.name || child.first_name || '').charAt(0)}
          </span>
        </button>
      ))}
    </div>
  );
};

export default ViewSwitcher;